module.exports = __webpack_public_path__ + "static/media/total-manager-icon.51fd70f3.svg";